export const API_URL = "https://hgoc1gxdu2.execute-api.eu-west-2.amazonaws.com/prod/adblockerdownloads/2";

export const ADBLOCKER_URL = "https://adblockultimate.net/browsers";